export const domainSchema = () => {
    return (
        {
            form_id: {
                type: 'text',
                label: 'Form ID',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            domain: {
                type: 'text',
                label: 'Domain',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Domain is required';
                    return null;
                },
            },
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            }
        }
    )
}
